import React from 'react';
import { FormattedMessage } from 'react-intl';

const InclTaxLabel: React.FC = () => (
  <span className="text-xs font-normal text-lowest" data-testid="incl-tax-label">
    <FormattedMessage id="price.inclTax" defaultMessage="(incl. tax)" />
  </span>
);

export default InclTaxLabel;
